export const NOT_SELECTED_ID = "notselected";

export interface Organizacja {
  Id: string;
  Nazwa: string;
  Produkty: Produkt[];
}

export interface OrganizacjaWidok {
  Id: string;
  IdZaproszenia: string;
  Nazwa: string;
  Produkty: Produkt[];
  Rola: RolaUzytkownika;
  CzyMoznaAdministrowac: Boolean;
}

export interface OdczytZaproszenia {
  Email: string;
  NazwaOrganizacji: string;
  NazwaZapraszajacego: string;
}

export interface Zaproszenie {
  IdZaproszenia: string;
  Email: string;
  Rola: RolaUzytkownika;
  Produkty: Produkt[];
  Wiadomosc: string;
}

export enum Produkt {
  Brunet = "Brunet",
  Zioom = "Zioom",
  Ksef = "Ksef"
}

export enum RolaUzytkownika {
  Uzytkownik = "Uzytkownik",
  Administrator = "Administrator",
  Wlasciciel = "Wlasciciel",
}

export interface OrganizacjeAction {
  type: string;
  lista: OrganizacjaWidok[];
  error: string;
  wybrana: OrganizacjaWidok;
}

export const organizacjeConsts = {
  DODAJ_ORGANIZACJE_REQUEST: "DODAJ_ORGANIZACJE_REQUEST",
  DODAJ_ORGANIZACJE_SUCCESS: "DODAJ_ORGANIZACJE_SUCCESS",
  DODAJ_ORGANIZACJE_FAILURE: "DODAJ_ORGANIZACJE_FAILURE",

  EDYTUJ_ORGANIZACJE_REQUEST: "EDYTUJ_ORGANIZACJE_REQUEST",
  EDYTUJ_ORGANIZACJE_SUCCESS: "EDYTUJ_ORGANIZACJE_SUCCESS",
  EDYTUJ_ORGANIZACJE_FAILURE: "EDYTUJ_ORGANIZACJE_FAILURE",

  DAJ_ORGANIZACJE_REQUEST: "DAJ_ORGANIZACJE_REQUEST",
  DAJ_ORGANIZACJE_SUCCESS: "DAJ_ORGANIZACJE_SUCCESS",
  DAJ_ORGANIZACJE_FAILURE: "DAJ_ORGANIZACJE_FAILURE",

  DAJ_WYBRANA_ORGANIZACJE_REQUEST: "DAJ_WYBRANA_ORGANIZACJE_REQUEST",
  DAJ_WYBRANA_ORGANIZACJE_SUCCESS: "DAJ_WYBRANA_ORGANIZACJE_SUCCESS",
  DAJ_WYBRANA_ORGANIZACJE_FAILURE: "DAJ_WYBRANA_ORGANIZACJE_FAILURE",

  ZMIEN_WYBRANA_ORGANIZACJE_REQUEST: "ZMIEN_WYBRANA_ORGANIZACJE_REQUEST",
  ZMIEN_WYBRANA_ORGANIZACJE: "ZMIEN_WYBRANA_ORGANIZACJE",
  ZMIEN_WYBRANA_ORGANIZACJE_FAILURE: "ZMIEN_WYBRANA_ORGANIZACJE_FAILURE",

  USUN_ORGANIZACJE_REQUEST: "USUN_ORGANIZACJE_REQUEST",
  USUN_ORGANIZACJE_SUCCESS: "USUN_ORGANIZACJE_SUCCESS",
  USUN_ORGANIZACJE_FAILURE: "USUN_ORGANIZACJE_FAILURE",

  PRZEGLADAJ_ORGANIZACJE_REQUEST: "PRZEGLADAJ_ORGANIZACJE_REQUEST",
  PRZEGLADAJ_ORGANIZACJE_SUCCESS: "PRZEGLADAJ_ORGANIZACJE_SUCCESS",
  PRZEGLADAJ_ORGANIZACJE_FAILURE: "PRZEGLADAJ_ORGANIZACJE_FAILURE",

  DAJ_ZAPROSZENIE_REQUEST: "DAJ_ZAPROSZENIE_REQUEST",
  DAJ_ZAPROSZENIE_SUCCESS: "DAJ_ZAPROSZENIE_SUCCESS",
  DAJ_ZAPROSZENIE_FAILURE: "DAJ_ZAPROSZENIE_FAILURE",

  ODRZUC_ZAPROSZENIE_REQUEST: "ODRZUC_ZAPROSZENIE_REQUEST",
  ODRZUC_ZAPROSZENIE_SUCCESS: "ODRZUC_ZAPROSZENIE_SUCCESS",
  ODRZUC_ZAPROSZENIE_FAILURE: "ODRZUC_ZAPROSZENIE_FAILURE",

  POTWIERDZ_ZAPROSZENIE_REQUEST: "POTWIERDZ_ZAPROSZENIE_REQUEST",
  POTWIERDZ_ZAPROSZENIE_SUCCESS: "POTWIERDZ_ZAPROSZENIE_SUCCESS",
  POTWIERDZ_ZAPROSZENIE_FAILURE: "POTWIERDZ_ZAPROSZENIE_FAILURE",
};
